<template>
  <div class="log">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        v-model="form"
        @on-load="getList"
        :search.sync="search"
        @sort-change="sortChange"
        :header-cell-class-name="headerCell"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-update="update"
        @size-change="sizeChange"
        :cell-style="cellStyle"
        @current-change="currentChange"
      >
        <template slot="sourceId" slot-scope="scope">
          <el-badge
            :value="getStatus(parseInt(scope.row.sortTime))"
            class="item"
            :type="getType(scope.row.sortTime)"
          >
            <el-badge
              :value="scope.row.firstFlag === 1 ? '首单' : ''"
              class="item badge-item"
            >
              <el-link type="primary" @click="tagClick(scope.row.sourceId, 1)">
                {{ scope.row.sourceId }}
              </el-link>
            </el-badge>
          </el-badge>
        </template>
        <template slot="orderId" slot-scope="scope">
          <el-link
            type="primary"
            @click="tagClick(scope.row.flowId, 2, parseInt(scope.row.sortTime))"
          >
            {{ scope.row.orderId }}
          </el-link>
        </template>
        <template slot="limitTime" slot-scope="scope">
          <span>{{ formatDate(scope.row.limitTime) }}</span>
        </template>
        <template slot="slan" slot-scope="scope">
          <span>
            {{ $sysLan.get(scope.row.slan) }}-{{ $sysLan.get(scope.row.tlan) }}
          </span>
        </template>
        <template slot="pmName" slot-scope="scope">
          <span>
            {{
              scope.row.pmName
                ? pmOptions.find((it) => it.username === scope.row.pmName)
                    ?.label
                : '--'
            }}
          </span>
        </template>
        <template slot="search" slot-scope="{ row, size }">
          <el-input
            placeholder="轻任务订单号"
            :size="size"
            style="width: 200px"
            clearable
            v-model="search.text"
          ></el-input>
        </template>
      </avue-crud>
    </basic-container>

    <el-dialog
      :visible.sync="dialogConfirmVisible"
      :title="toggoleItemFlag ? toggoleItemText1 : toggoleItemText2"
      width="50%"
      @close="dialogConfirmVisible = false"
    >
      <avue-form
        :option="confirmOption"
        v-model="confirmObj"
        @submit="confirmSubmit"
        @error="error"
      >
        <template slot-scope="scope" slot="menuForm">
          <el-button @click="cancelItem2">取消</el-button>
        </template>
      </avue-form>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogFormStatus"
      width="70%"
      title="修改项目信息"
      @close="dialogFormStatus = false"
    >
      <avue-form
        :option="statusOption"
        v-model="statusObj"
        @submit="statusSubmit"
        @error="error"
      >
        <template slot-scope="scope" slot="menuForm">
          <el-button @click="cancelItem">取消</el-button>
        </template>
        <template slot-scope="scope" slot="limitTime">
          <el-date-picker
            :class="{
              red: isLimitTime(
                0,
                statusObj.limitTime,
                statusObj.recommendLimitTime,
              ),
            }"
            v-model="statusObj.limitTime"
            :picker-options="pickerOptions"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期时间"
          ></el-date-picker>
          <span
            style="color: darkgray"
            v-if="
              isLimitTime(0, detailObj.limitTime, detailObj.recommendLimitTime)
            "
          >
            {{ '推荐截止日期为: ' + formatRecommendLimitTime }}
          </span>
        </template>
        <template slot="pmName" slot-scope="scope">
          <el-input disabled v-model="pmName" min="1"></el-input>
        </template>
        <template slot-scope="scope" slot="pePrice">
          <div style="display: flex">
            <el-input-number
              :class="{ red: pePriceChange(statusObj) }"
              size="medium"
              :precision="2"
              :step="1"
              controls-position="right"
              v-model="statusObj.pePrice"
            ></el-input-number>
            <div class="input-group__append">元/千字</div>
          </div>
          <span style="color: darkgray" v-if="pePriceChange(statusObj)">
            {{ '推荐值为: ' + statusObj.recommendPePrice }}
          </span>
        </template>
        <template slot-scope="scope" slot="maxPeTime">
          <div style="display: flex">
            <el-input-number
              :class="{
                red: isLimitTime(
                  1,
                  statusObj.maxPeTime,
                  statusObj.recommendMaxPeTime,
                ),
              }"
              size="medium"
              :precision="2"
              :step="1"
              controls-position="right"
              v-model="statusObj.maxPeTime"
            ></el-input-number>
            <div class="input-group__append">秒/字</div>
          </div>
          <span
            style="color: darkgray"
            v-if="
              isLimitTime(1, statusObj.maxPeTime, statusObj.recommendMaxPeTime)
            "
          >
            {{ '推荐值为: ' + statusObj.recommendMaxPeTime }}
          </span>
        </template>
        <template slot-scope="scope" slot="modifyLimitTime">
          <div style="display: flex">
            <el-input-number
              :class="{
                red: isLimitTime(
                  1,
                  statusObj.modifyLimitTime,
                  statusObj.recommendModifyLimitTime,
                ),
              }"
              size="medium"
              :precision="2"
              :step="1"
              controls-position="right"
              v-model="statusObj.modifyLimitTime"
            ></el-input-number>
            <div class="input-group__append">小时</div>
          </div>
          <span
            style="color: darkgray"
            v-if="
              isLimitTime(
                1,
                statusObj.modifyLimitTime,
                statusObj.recommendModifyLimitTime,
              )
            "
          >
            {{ '推荐值为: ' + statusObj.recommendModifyLimitTime }}
          </span>
        </template>
        <template slot-scope="scope" slot="peAuditPrice">
          <div style="display: flex">
            <el-input-number
              :class="{ red: peAuditPriceChange(statusObj) }"
              size="medium"
              :precision="2"
              :step="1"
              controls-position="right"
              v-model="statusObj.peAuditPrice"
            ></el-input-number>
            <div class="input-group__append">元/千字</div>
          </div>
          <span style="color: darkgray" v-if="peAuditPriceChange(statusObj)">
            {{ '推荐值为: ' + statusObj.recommendPeAuditPrice }}
          </span>
        </template>
        <template slot-scope="scope" slot="maxPeAuditTime">
          <div style="display: flex">
            <el-input-number
              :class="{
                red: isLimitTime(
                  1,
                  statusObj.maxPeAuditTime,
                  statusObj.recommendMaxPeAuditTime,
                ),
              }"
              size="medium"
              :precision="2"
              :step="1"
              controls-position="right"
              v-model="statusObj.maxPeAuditTime"
            ></el-input-number>
            <div class="input-group__append">秒/字</div>
          </div>
          <span
            style="color: darkgray"
            v-if="
              isLimitTime(
                1,
                statusObj.maxPeAuditTime,
                statusObj.recommendMaxPeAuditTime,
              )
            "
          >
            {{ '推荐值为: ' + statusObj.recommendMaxPeAuditTime }}
          </span>
        </template>
      </avue-form>
    </el-dialog>
    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      size="60%"
      :before-close="handleClose"
    >
      <el-breadcrumb class="bread-left" separator="/">
        <el-breadcrumb-item>
          <a href="/centralControl/examine">中控系统</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a href="/centralControl/examine">异常项目审批</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>查看详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row class="row-first">
        <el-col :span="4">
          <div class="bg-left grid-content bg-purple">
            语种风险值({{ riskInfoObj.dotFlowRisk.lanRisk }})
          </div>
        </el-col>
        <el-col :span="4">
          <div class="bg-left grid-content bg-purple-light">
            规模风险值({{ riskInfoObj.dotFlowRisk.scaleRisk }})
          </div>
        </el-col>
        <el-col :span="4">
          <div class="bg-left grid-content bg-purple">
            时间风险值({{ riskInfoObj.dotFlowRisk.timeRisk }})
          </div>
        </el-col>
        <el-col :span="4">
          <div class="bg-left grid-content bg-purple-light">
            资源风险值({{ riskInfoObj.dotFlowRisk.trRisk }})
          </div>
        </el-col>
        <el-col :span="4">
          <div class="bg-left bg-right grid-content bg-purple">
            客户风险值({{ riskInfoObj.dotFlowRisk.custRisk }})
          </div>
        </el-col>
      </el-row>
      <el-row class="row-second">
        <el-col :span="6" class="row-total">
          风险总值:{{ riskInfoObj.totalRisk }}
        </el-col>
        <el-col :span="4" class="row-total">
          风险等级:{{ riskInfoObj.riskLevel }}级
        </el-col>
        <el-divider />
        <el-steps align-center class="el-card__body">
          <template v-for="item in detailObj.flows">
            <el-step
              :title="$flowType.get(item.orderFlow)"
              :status="getFlowStatus(item.status)"
            >
              <template slot="description" slot-scope="scope">
                <!-- -1.已终止，0未开始 1.待配置，2.待领取，3.进行中，4.已完成-->
                <span>（{{ $flowStatus.get(item.status) }}）</span>
                <br />
                <span
                  v-if="item.finishTime != null && item.status === 4"
                  v-text="formatDate(item.finishTime)"
                ></span>
              </template>
            </el-step>
          </template>
        </el-steps>
      </el-row>
      <el-tabs
        class="row-second"
        v-model="activeName"
        @tab-click="handleClick(activeName)"
      >
        <el-tab-pane label="订单详情" name="first">
          <avue-form
            class="form-detail"
            :option="detailOption"
            v-model="detailObj"
            @submit="statusSubmit"
            @error="error"
          >
            <template slot-scope="scope" slot="slan">
              <el-input v-model="lan"></el-input>
            </template>
            <template slot="pmName" slot-scope="scope">
              <el-input disabled v-model="pmName"></el-input>
            </template>
            <template slot-scope="scope" slot="limitTime">
              <!--              <el-input :class="{ 'red': isLimitTime(0,detailObj.orgLimitTime,detailObj.recommendLimitTime) }" v-model="detailObj.limitTime"></el-input>-->
              <el-tooltip
                placement="top"
                :disabled="
                  !isLimitTime(
                    0,
                    detailObj.limitTime,
                    detailObj.recommendLimitTime,
                  )
                "
                :content="'推荐截止日期为: ' + formatRecommendLimitTime"
              >
                <el-date-picker
                  :class="{
                    red: isLimitTime(
                      0,
                      detailObj.limitTime,
                      detailObj.recommendLimitTime,
                    ),
                  }"
                  v-model="detailObj.limitTime"
                  type="datetime"
                  value-format="timestamp"
                  disabled
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-tooltip>
            </template>
            <template slot-scope="scope" slot="pePrice">
              <el-tooltip
                :disabled="!pePriceChange(detailObj)"
                :content="'推荐值为: ' + detailObj.recommendPePrice"
                placement="top"
              >
                <el-input
                  disabled
                  :class="{ red: pePriceChange(detailObj) }"
                  v-model="detailObj.pePrice"
                >
                  <template slot="append">元/千字</template>
                </el-input>
              </el-tooltip>
            </template>
            <template slot-scope="scope" slot="maxPeTime">
              <el-tooltip
                :disabled="
                  !isLimitTime(
                    1,
                    detailObj.maxPeTime,
                    detailObj.recommendMaxPeTime,
                  )
                "
                :content="'推荐值为: ' + detailObj.recommendMaxPeTime"
                placement="top"
              >
                <el-input
                  disabled
                  :class="{
                    red: isLimitTime(
                      1,
                      detailObj.maxPeTime,
                      detailObj.recommendMaxPeTime,
                    ),
                  }"
                  v-model="detailObj.maxPeTime"
                >
                  <template slot="append">秒/字</template>
                </el-input>
              </el-tooltip>
            </template>
            <template slot-scope="scope" slot="modifyLimitTime">
              <el-tooltip
                :disabled="
                  !isLimitTime(
                    1,
                    detailObj.modifyLimitTime,
                    detailObj.recommendModifyLimitTime,
                  )
                "
                :content="'推荐值为: ' + detailObj.recommendModifyLimitTime"
                placement="top"
              >
                <el-input
                  disabled
                  :class="{
                    red: isLimitTime(
                      1,
                      detailObj.modifyLimitTime,
                      detailObj.recommendModifyLimitTime,
                    ),
                  }"
                  v-model="detailObj.modifyLimitTime"
                >
                  <template slot="append">小时</template>
                </el-input>
              </el-tooltip>
            </template>
            <template slot-scope="scope" slot="peAuditPrice">
              <el-tooltip
                :disabled="!peAuditPriceChange(detailObj)"
                :content="'推荐值为: ' + detailObj.recommendPeAuditPrice"
                placement="top"
              >
                <el-input
                  disabled
                  :class="{ red: peAuditPriceChange(detailObj) }"
                  v-model="detailObj.peAuditPrice"
                >
                  <template slot="append">元/千字</template>
                </el-input>
              </el-tooltip>
            </template>
            <template slot-scope="scope" slot="maxPeAuditTime">
              <el-tooltip
                :disabled="
                  !isLimitTime(
                    1,
                    detailObj.maxPeAuditTime,
                    detailObj.recommendMaxPeAuditTime,
                  )
                "
                :content="'推荐值为: ' + detailObj.recommendMaxPeAuditTime"
                placement="top"
              >
                <el-input
                  disabled
                  :class="{
                    red: isLimitTime(
                      1,
                      detailObj.maxPeAuditTime,
                      detailObj.recommendMaxPeAuditTime,
                    ),
                  }"
                  v-model="detailObj.maxPeAuditTime"
                >
                  <template slot="append">秒/字</template>
                </el-input>
              </el-tooltip>
            </template>
          </avue-form>
        </el-tab-pane>
        <el-tab-pane label="操作日志" name="second">
          <avue-crud
            :data="logData"
            :option="logOption"
            :table-loading="logTableLoading"
            :page.sync="logPage"
            @on-load="getLogList"
            @size-change="logSizeChange"
            @current-change="logCurrentChange"
            @row-save="logSave"
          ></avue-crud>
        </el-tab-pane>
      </el-tabs>
      <el-row class="button-bottom">
        <el-button
          type="success"
          plain
          :disabled="startTaskFlag"
          @click="markingStatusChange()"
        >
          修改信息
        </el-button>
        <el-button
          type="danger"
          @click="toggoleItem(1)"
          :disabled="startTaskFlag"
        >
          {{ toggoleItemText1 }}
        </el-button>
        <el-button
          type="primary"
          @click="toggoleItem(2)"
          :disabled="startTaskFlag"
        >
          {{ toggoleItemText2 }}
        </el-button>
      </el-row>
    </el-drawer>
  </div>
</template>

<script>
import {
  addLog,
  cancelFlow,
  confirmStartPe,
  dotFlowStatusEnum,
  pendingTaskList,
  updatePeInfo,
} from '@/api/centralControl/examine';
import { tableOption } from '@/const/crud/centralControl/examine';
import { mapGetters, mapState } from 'vuex';
import {
  listByRoleCode,
  logList,
  riskInfoByFlowId,
  taskInfoByFlowId,
} from '@/api/centralControl/ongoingTask';
import { statistics } from '@/api/dot/flow';
import { jsonFlatten } from '@/util/util';
import { formatDate } from '@/util/date';
// import {validatePass,validatePass2} from "@/util/rule";
import { $sysLan } from '@/config/status';

export default {
  name: 'log',
  data() {
    return {
      search: {
        status: null,
      },
      toggoleItemFlag: true,
      toggoleItemText1: '确认开始',
      toggoleItemText2: '取消任务',
      drawer: false,
      direction: 'rtl',
      activeName: 'first',
      statusOptions: [],
      pmOptions: [],
      form: {},
      startTaskFlag: false,
      dialogFormVisible: false, //表格显示隐藏
      dialogFormStatus: false, //表格显示隐藏
      dialogConfirmVisible: false, //表格显示隐藏
      dic: [
        {
          label: '开启',
          value: 1,
        },
        {
          label: '关闭',
          value: 2,
        },
      ],
      credibility: '',
      tableData: [],
      logData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      logPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      tableLoading: false,
      logTableLoading: false,
      statusObj: {},
      originStatusObj: {},
      detailObj: {},
      confirmObj: {},
      tableOption: tableOption,
      riskInfoObj: {
        totalRisk: 0,
        riskLevel: 0,
        dotFlowRisk: {
          lanRisk: 0,
          scaleRisk: 0,
          timeRisk: 0,
          trRisk: 0,
          custRisk: 0,
        },
      },
      pickerOptions: {
        disabledDate: (time) => {
          let nowData = new Date();
          nowData = new Date(nowData.setDate(nowData.getDate() - 1));
          return time < nowData;
        },
      },
      logOption: {
        addBtn: true,
        menu: false,
        align: 'center',
        menuAlign: 'center',
        column: [
          {
            label: '时间',
            prop: 'createTime',
            minWidth: 120,
            addDisplay: false,
            // type: "datetime",
            // format:'yyyy-MM-dd hh:mm:ss',
            // valueFormat:'yyyy-MM-dd hh:mm:ss',
          },
          {
            label: '事项',
            minWidth: 550,
            row: true,
            span: 24,
            addDisplay: false,
            prop: 'content',
          },
          {
            label: '备注',
            row: true,
            span: 24,
            type: 'textarea',
            maxlength: 200,
            rules: {
              required: true,
              message: '请输入事项',
              trigger: 'blur',
            },
            showWordLimit: true,
            prop: 'remark',
          },
          {
            label: '操作人',
            minWidth: 80,
            addDisplay: false,
            prop: 'operationName',
          },
        ],
      },
      confirmOption: {
        emptyBtn: false,
        column: [
          {
            label: '',
            labelWidth: 40,
            prop: 'sp1',
            component: 'sapn', //ele分割线
            span: 24,
            params: {
              html: '<h3 style="color:#00bfbf">请填写与PM沟通一致的结论信息</h3>',
              contentPosition: 'left',
            },
          },
          {
            label: '',
            labelWidth: 0,
            placeholder: '请填写与PM达成一致的结论和沟通时间',
            labelPosition: 'top',
            row: true,
            span: 24,
            type: 'textarea',
            maxlength: 200,
            rules: {
              required: true,
              message: '请填写与PM沟通一致的结论信息',
              trigger: 'blur',
            },
            showWordLimit: true,
            prop: 'remark',
          },
        ],
      },
      statusOption: {
        emptyBtn: false,
        group: [
          {
            label: '',
            column: [
              {
                label: '',
                labelWidth: 40,
                prop: 'sp1',
                component: 'span', //ele分割线
                span: 24,
                params: {
                  html: '<h3 style="color:#00bfbf">请与PM沟通一致后再修改项目要求完成时间、单价等信息</h3>',
                  contentPosition: 'left',
                },
              },
              {
                label: '轻任务订单号',
                labelPosition: 'left',
                className: 'formClassName2',
                disabled: true,
                labelWidth: 130,
                width: 310,
                prop: 'orderId',
                searchLabelWidth: 130,
                span: 12,
              },
              {
                label: '来源订单',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                width: 310,
                prop: 'sourceId',
                span: 12,
              },
              {
                label: '任务总字数',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                prop: 'totalWords',
              },
              {
                label: '客户名称',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                prop: 'custName',
              },
              {
                label: '发起人',
                labelPosition: 'left',
                className: 'formClassName2',
                disabled: true,
                prop: 'pmName',
                labelWidth: 130,
              },
              {
                label: '语种',
                labelPosition: 'left',
                className: 'formClassName2',
                disabled: true,
                labelWidth: 130,
                prop: 'slan',
              },
              {
                label: '任务创建时间',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                prop: 'createTime',
                // type: "datetime",
                // format:'yyyy-MM-dd hh:mm:ss',
                // valueFormat:'yyyy-MM-dd hh:mm:ss',
              },
              {
                label: '任务截止时间',
                labelPosition: 'left',
                className: 'formClassName2',
                formslot: true,
                labelslot: true,
                labelWidth: 130,
                prop: 'limitTime',
                type: 'datetime',
                format: 'yyyy-MM-dd hh:mm:ss',
                valueFormat: 'yyyy-MM-dd hh:mm:ss',
              },
            ],
          },
          {
            label: 'PE设置',
            prop: 'tksq',
            column: [
              {
                label: 'PE价格',
                labelPosition: 'left',
                className: 'formClassName',
                formslot: true,
                labelslot: true,
                labelWidth: 130,
                append: '元/千字',
                rules: [
                  {
                    required: true,
                    message: '请输入PE价格',
                    trigger: 'blur',
                  },
                ],
                prop: 'pePrice',
              },
            ],
          },
          {
            label: '',
            prop: 'dddd',
            column: [
              {
                label: '',
                labelWidth: 40,
                prop: 'sp1',
                component: 'elDivider', //ele分割线
                span: 24,
                params: {
                  html: '<h3 style="color:#00bfbf">请填写与PM沟通一致的结论信息</h3>',
                  contentPosition: 'left',
                },
              },
              {
                label: '',
                labelWidth: 0,
                placeholder: '请填写与PM沟通一致的结论信息',
                labelPosition: 'top',
                row: true,
                span: 24,
                type: 'textarea',
                maxlength: 200,
                rules: {
                  required: true,
                  message: '请填写与PM沟通一致的结论信息',
                  trigger: 'blur',
                },
                showWordLimit: true,
                prop: 'remark',
              },
            ],
          },
        ],
      },
      detailOption: {
        emptyBtn: false,
        submitBtn: false,
        detail: true,
        group: [
          {
            label: '',
            column: [
              {
                label: '轻任务订单号',
                labelPosition: 'left',
                className: 'formClassName2',
                disabled: true,
                labelWidth: 130,
                width: 310,
                prop: 'orderId',
                searchLabelWidth: 130,
                span: 12,
              },
              {
                label: '来源订单',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                width: 310,
                prop: 'sourceId',
                span: 12,
              },
              {
                label: '任务总字数',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                prop: 'totalWords',
              },
              {
                label: '客户名称',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                prop: 'custName',
              },
              {
                label: '发起人',
                labelPosition: 'left',
                className: 'formClassName2',
                disabled: true,
                prop: 'pmName',
                labelWidth: 130,
              },
              {
                label: '语种',
                labelPosition: 'left',
                className: 'formClassName2',
                disabled: true,
                labelWidth: 130,
                prop: 'slan',
              },
              {
                label: '任务创建时间',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                prop: 'createTime',
                // type: "datetime",
                // format:'yyyy-MM-dd hh:mm:ss',
                // valueFormat:'yyyy-MM-dd hh:mm:ss',
              },
              {
                label: '任务截止时间',
                labelPosition: 'left',
                className: 'formClassName2',
                labelWidth: 130,
                formslot: true,
                labelslot: true,
                prop: 'limitTime',
                type: 'datetime',
                format: 'yyyy-MM-dd hh:mm:ss',
                valueFormat: 'yyyy-MM-dd hh:mm:ss',
              },
            ],
          },
          {
            label: 'PE设置',
            prop: 'tksq',
            column: [
              {
                label: 'PE价格',
                labelPosition: 'left',
                className: 'formClassName',
                formslot: true,
                labelslot: true,
                disabled: true,
                labelWidth: 130,
                append: '元/千字',
                rules: [
                  {
                    required: true,
                    message: '请输入PE价格',
                    trigger: 'blur',
                  },
                ],
                prop: 'pePrice',
              },
            ],
          },
        ],
      },
      staParams: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  computed: {
    ...mapGetters(['permissions', 'userInfo']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    lan() {
      return (
        $sysLan.get(this.detailObj.slan) +
        '--' +
        $sysLan.get(this.detailObj.tlan)
      );
    },
    formatRecommendLimitTime() {
      let date = new Date(parseFloat(this.detailObj.recommendLimitTime));
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
    },
    pmName() {
      return this.detailObj.pmName
        ? this.pmOptions.find((it) => it.username === this.detailObj.pmName)
            ?.label
        : '--';
    },
  },
  mounted() {
    dotFlowStatusEnum().then((res) => {
      this.tableOption.column[8].dicData = res.data.data;
      this.statusOptions = res.data.data.filter(
        (it) => it.value === -3 || it.value === -4,
      );
    });

    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      scene_name: '异常项目审批',
    };
    this.statistics();
  },
  methods: {
    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
            ref_url: this.oldPath,
          },
          this.staParams,
        ),
      );
    },

    // 排序改变
    sortChange(column) {
      this.getList(this.page, {
        prop: column.prop,
        order: column.order,
      });
    },
    // 比较方法
    isLimitTime(type, source, recommend) {
      if (type === 0) {
        return source < recommend;
      } else {
        return source >= 3 * recommend || source <= recommend / 3;
      }
    },
    // pe价格
    pePriceChange(detailObj) {
      if (detailObj.slan === 'zh-CN' && detailObj.tlan === 'en') {
        return (
          detailObj.pePrice < 10 ||
          detailObj.pePrice >= 3 * detailObj.recommendPePrice
        );
      } else if (detailObj.slan === 'en' && detailObj.tlan === 'zh-CN') {
        return (
          detailObj.pePrice < 14 ||
          detailObj.pePrice >= 3 * detailObj.recommendPePrice
        );
      } else {
        return (
          detailObj.pePrice <= detailObj.recommendPePrice / 3 ||
          detailObj.pePrice >= 3 * detailObj.recommendPePrice
        );
      }
    },
    // pe审核价格
    peAuditPriceChange(detailObj) {
      if (detailObj.slan === 'zh-CN' && detailObj.tlan === 'en') {
        return (
          detailObj.peAuditPrice < 14 ||
          detailObj.peAuditPrice >= 3 * detailObj.recommendPeAuditPrice
        );
      } else if (detailObj.slan === 'en' && detailObj.tlan === 'zh-CN') {
        return (
          detailObj.peAuditPrice < 19 ||
          detailObj.peAuditPrice >= 3 * detailObj.recommendPeAuditPrice
        );
      } else {
        return (
          detailObj.peAuditPrice <= detailObj.recommendPeAuditPrice / 3 ||
          detailObj.peAuditPrice >= 3 * detailObj.recommendPeAuditPrice
        );
      }
    },
    getFlowStatus(status) {
      if (status === 3) {
        return 'finish';
      } else {
        return 'wait';
      }
    },
    getLogList(page, params) {
      this.logTableLoading = true;
      logList(
        Object.assign(
          {
            flowId: this.flowId,
            pageNo: page.currentPage,
            pageSize: page.pageSize,
          },
          params,
        ),
      ).then((res) => {
        let logData = res.data.data;
        if (logData) {
          logData.records.forEach(
            (i) =>
              (i.createTime = formatDate(
                new Date(parseFloat(i.createTime)),
                'yyyy-MM-dd hh:mm:ss',
              )),
          );
          this.logData = logData.records;
          this.logPage.total = logData.total;
          this.logTableLoading = false;
        } else {
          this.logData = [];
          this.logPage.total = 0;
          this.logTableLoading = false;
        }
      });
    },
    // 日志新增
    logSave(row, done, loading) {
      addLog(
        Object.assign({
          flowId: this.flowId,
          userId: this.userInfo.staffId,
          remark: row.remark,
        }),
      )
        .then((res) => {
          // 操作日志
          if (res.data.data && res.data.data > 0) {
            this.getLogList(this.logPage);
          }
          done();
          this.$notify.success('日志新增成功');
        })
        .catch(() => {
          this.$notify.error('日志新增失败');
          loading();
        });
    },
    getStatus(value) {
      if (value > 0) {
        return '置顶';
      } else if (value === 0) {
        return '';
      } else {
        return '置底';
      }
    },
    getType(value) {
      if (value > 0) {
        return 'success';
      } else if (value === 0) {
        return 'info';
      } else {
        return 'warning ';
      }
    },
    formatDate(time) {
      let date = new Date(parseFloat(time));
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    },
    // 获取当前事情
    getNowFormatDate() {
      let date = new Date();
      let year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      let hours =
        date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      let minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      let seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds
      );
    },
    // 取消编辑
    cancelItem() {
      this.dialogFormStatus = false;
    },
    // 取消编辑
    cancelItem2() {
      this.dialogConfirmVisible = false;
      // this.toggoleItemFlag = false;
    },
    // 确认开始
    toggoleItem(value) {
      // this.toggoleItemFlag = !this.toggoleItemFlag;
      this.dialogConfirmVisible = true;
      this.toggoleItemFlag = value === 1;
    },
    // 导航栏
    handleClick(val) {
      if (val === 'first') {
        // 订单详情
        taskInfoByFlowId(
          Object.assign({
            flowId: this.flowId,
          }),
        ).then((res) => {
          if (res.data.data) {
            let obj = jsonFlatten(res.data.data);
            obj.createTime = formatDate(
              new Date(parseFloat(obj.createTime)),
              'yyyy-MM-dd hh:mm:ss',
            );
            // obj.limitTime = formatDate(new Date(parseFloat(obj.limitTime)), 'yyyy-MM-dd hh:mm:ss')
            this.detailObj = obj;
          }
        });
      } else {
        this.getLogList(this.logPage);
      }
    },
    // 右边弹窗关闭方法
    handleClose(done) {
      done();
    },
    // 单元格样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 9) {
        if (row.riskLevel === 5) {
          return {
            backgroundColor: '#FF2525',
          };
        } else if (row.riskLevel === 4) {
          return {
            backgroundColor: '#FF6200',
          };
        } else if (row.riskLevel === 3) {
          return {
            backgroundColor: '#FCCA00 ',
          };
        } else if (row.riskLevel === 2) {
          return {
            backgroundColor: '#27B148',
          };
        } else if (row.riskLevel === 1) {
          return {
            backgroundColor: '#00C7FF',
          };
        }
      }
    },
    tagClick(data, type) {
      if (type === 1) {
        this.$message({
          message: '复制成功，内容为：' + data,
          type: 'success',
        });
        let input = document.createElement('input'); // js创建一个input输入框
        input.value = data; // 将需要复制的文本赋值到创建的input输入框中，this.ruleForm.url这个是我要复制的内容
        document.body.appendChild(input); // 将输入框暂时创建到实例里面
        input.select(); // 选中输入框中的内容
        document.execCommand('Copy'); // 执行复制操作
        document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
      } else {
        this.flowId = data;
        // 订单详情
        taskInfoByFlowId(
          Object.assign({
            flowId: data,
          }),
        ).then((res) => {
          if (res.data.data) {
            let obj = jsonFlatten(res.data.data);
            obj.createTime = formatDate(
              new Date(parseFloat(obj.createTime)),
              'yyyy-MM-dd hh:mm:ss',
            );
            // obj.limitTime = formatDate(new Date(parseFloat(obj.limitTime)), 'yyyy-MM-dd hh:mm:ss')
            obj.flows = res.data.data.flows;
            this.detailObj = obj;
            this.statusObj = obj;
            this.statusObj.remark = '';
            obj.remark = '';
            this.originStatusObj = obj;
          }
        });
        // 风险详情
        riskInfoByFlowId(
          Object.assign({
            flowId: data,
          }),
        ).then((res) => {
          if (res.data.data && res.data.data.dotFlowRisk) {
            this.riskInfoObj = res.data.data;
          } else {
            this.riskInfoObj.riskLevel = res.data.data.riskLevel;
            this.riskInfoObj.totalRisk = res.data.data.totalRisk;
            for (let k in this.riskInfoObj.dotFlowRisk) {
              this.riskInfoObj.dotFlowRisk[k] = 0;
            }
          }
        });
        this.drawer = true;
      }
    },
    markingStatusChange(data) {
      this.dialogFormStatus = true;
    },
    statusSubmit(form, done) {
      let obj = Object.assign({
        userId: this.userInfo.staffId,
        flowId: this.flowId,
        limitTime: this.statusObj.limitTime,
        pePrice: this.statusObj.pePrice,
        maxPeTime: this.statusObj.maxPeTime,
        modifyLimitTime: this.statusObj.modifyLimitTime,
        auditPrice: this.statusObj.peAuditPrice,
        maxPeAuditTime: this.statusObj.maxPeAuditTime,
        remark: this.statusObj.remark,
      });
      // 如果input框值为修改，则不用传递到后端
      if (this.originStatusObj.limitTime === this.statusObj.limitTime) {
        obj.limitTime = '';
      }
      if (this.originStatusObj.pePrice === this.statusObj.pePrice) {
        obj.pePrice = '';
      }
      if (this.originStatusObj.maxPeTime === this.statusObj.maxPeTime) {
        obj.maxPeTime = '';
      }
      if (
        this.originStatusObj.modifyLimitTime === this.statusObj.modifyLimitTime
      ) {
        obj.modifyLimitTime = '';
      }
      if (this.originStatusObj.peAuditPrice === this.statusObj.peAuditPrice) {
        obj.peAuditPrice = '';
      }
      if (
        this.originStatusObj.maxPeAuditTime === this.statusObj.maxPeAuditTime
      ) {
        obj.maxPeAuditTime = '';
      }
      if (this.statusObj.limitTime < Date.parse(new Date())) {
        this.$message.error('任务截止时间必须大于当前时间');
        done();
        return;
      }
      if (this.statusObj.pePrice < 0) {
        this.$message.error('PE价格必须大于0');
        done();
        return;
      }
      if (this.statusObj.maxPeTime < 0) {
        this.$message.error('最长处理时长必须大于0');
        done();
        return;
      }
      if (this.statusObj.modifyLimitTime < 0) {
        this.$message.error('打回修改限制时长必须大于0');
        done();
        return;
      }
      if (this.statusObj.peAuditPrice < 0) {
        this.$message.error('PE审核价格必须大于0');
        done();
        return;
      }
      if (this.statusObj.maxPeAuditTime < 0) {
        this.$message.error('最长处理时长必须大于0');
        done();
        return;
      }
      updatePeInfo(obj)
        .then((res) => {
          if (res.data.data === 1) {
            // 订单详情
            taskInfoByFlowId(
              Object.assign({
                flowId: this.flowId,
              }),
            ).then((res) => {
              if (res.data.data) {
                let obj = jsonFlatten(res.data.data);
                obj.createTime = formatDate(
                  new Date(parseFloat(obj.createTime)),
                  'yyyy-MM-dd hh:mm:ss',
                );
                // obj.limitTime = formatDate(new Date(parseFloat(obj.limitTime)), 'yyyy-MM-dd hh:mm:ss')
                obj.flows = res.data.data.flows;
                this.detailObj = obj;
                this.statusObj = obj;
                this.statusObj.remark = '';
                obj.remark = '';
                this.originStatusObj = obj;
                this.getLogList(this.logPage);
              }
            });
            this.$notify.success('修改信息成功');
          } else {
            this.$notify.error('修改信息失败');
          }
        })
        .catch(() => {
          this.$notify.error('修改信息失败');
        });
      done();
      this.dialogFormStatus = false;
      statistics(
        Object.assign({
          event_name: '修改信息',
          event_type: 'click',
          class_name: 'updatePeInfo',
          class_url: '/dotadmin/dotRisk/updatePeInfo',
        }),
      );
    },
    confirmSubmit(form, done) {
      this.dialogConfirmVisible = !this.dialogConfirmVisible;
      this.toggoleItemFlag = !this.toggoleItemFlag;
      if (!this.toggoleItemFlag) {
        // 开始pe
        confirmStartPe(
          Object.assign({
            userId: this.userInfo.staffId,
            flowId: this.flowId,
            remark: this.confirmObj.remark,
          }),
        )
          .then((res) => {
            if (res.data.data > 0) {
              this.confirmObj.remark = '';
              this.drawer = false;
              this.$notify.success('任务发布成功');
            } else if (res.data.data === -1) {
              this.$notify.error('任务状态不对，不能开始PE');
            } else if (res.data.data === -2) {
              this.$notify.error('当前订单状态已修改，不能开始pe');
            }
          })
          .catch(() => {
            this.$notify.error('任务发布失败');
          })
          .then(() => {
            this.getList(this.page);
          });
        // this.startTaskFlag = true;
      } else {
        // 取消流程
        cancelFlow(
          Object.assign({
            staffId: this.userInfo.staffId,
            flowId: this.flowId,
            remark: this.confirmObj.remark,
          }),
        )
          .then((res) => {
            if (res.data.data > 0) {
              this.confirmObj.remark = '';
              this.drawer = false;
              this.$notify.success('任务状态已改变，请刷新后查看');
            } else {
              this.$notify.error('任务取消失败');
            }
          })
          .catch(() => {
            this.$notify.error('任务取消失败');
          })
          .then(() => {
            this.getList(this.page);
          });
        // this.startTaskFlag = true;
      }
      done();
    },
    error(err) {
      // this.$message.success('请查看控制台');
    },
    dialogFormVisible() {
      this.dialogFormVisible = false;
    },
    headerCell(row, column, rowIndex, columnIndex) {
      return 'test';
    },
    getList(page, params) {
      this.tableLoading = true;
      pendingTaskList(
        Object.assign(
          {
            pageNo: page.currentPage,
            pageSize: page.pageSize,
            text: this.search.text,
            // status: this.search.status
          },
          params,
        ),
      ).then((response) => {
        this.tableData = response.data.data.records;
        this.page.total = response.data.data.total;
        this.tableLoading = false;
        console.log(response.data.data.records, this.tableData);
      });
    },
    searchChange(form, done) {
      this.getList(this.page, form);
      done();
      statistics(
        Object.assign(
          {
            event_name: '搜索',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    currentChange(current) {
      this.page.currentPage = current;
    },
    logSizeChange(pageSize) {
      this.logPage.pageSize = pageSize;
    },
    logCurrentChange(current) {
      this.logPage.currentPage = current;
    },
    refreshChange() {
      this.getList(this.page);
    },
    update(row, index, done, loading) {
      putObj(this.form)
        .then(() => {
          this.getList(this.page);
          done();
          this.$notify.success('修改成功');
        })
        .catch(() => {
          loading();
        });
    },
  },
  beforeMount() {
    listByRoleCode(
      Object.assign({
        roleCode: 'DOT_PM',
      }),
    ).then((res) => {
      let result = res.data.data;
      this.pmOptions = result.map((it) => {
        return {
          value: it.staffId,
          // label: it.username
          label: it.realname,
          username: it.username,
        };
      });
    });
  },
  watch: {
    drawer(val) {
      if (!val) {
        this.activeName = 'first';
      }
    },
    dialogFormStatus(val) {
      if (!val) {
        this.statusObj = this.originStatusObj;
      }
    },
    dialogConfirmVisible(val) {
      if (!val) {
        this.confirmObj.remark = '';
      }
    },
  },
};
</script>
<style scoped>
.item {
  margin-top: 10px;
  margin-right: 40px;
}
.row-first {
  padding: 30px;
}
.row-second {
  padding-left: 50px;
  font-weight: bold;
}
.row-total {
  color: #00bfbf;
}
.bread-left {
  padding-left: 20px;
}
.button-bottom {
  padding: 24px;
  display: flex;
  justify-content: flex-end;
}
</style>
<style lang="scss" scoped>
:deep(.avue-form__group) {
  padding-top: 20px;
}
:deep(.el-form-item--mini.el-form-item),
:deep(.el-form-item--small.el-form-item) {
  margin-bottom: 0;
}
:deep(.el-input__inner) {
  text-align: center;
}
:deep(.el-col) {
  margin-bottom: 20px;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  text-align: center;
  border-radius: 4px;
}
:deep(.red input) {
  color: red !important;
}
:deep(.avue-group__title) {
  font-weight: 600;
}
:deep(.input-group__append) {
  background-color: #f5f7fa;
  color: #909399;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 60px 0 20px;
  width: 1px;
  white-space: nowrap;
}
</style>
